export const getBase64 = (img) => {
    return new Promise((resolve, reject) => {
        let fileReader = new FileReader();
        fileReader.onerror = reject;
        fileReader.onload = function () {
            resolve(fileReader.result);
        };
        fileReader.readAsDataURL(img);
    });
};